export const FormControlLabelConfig = {
    styleOverrides: {
        root: ({ theme }: { theme: any }) => {
            return {
                marginLeft: theme.spacing(-1),
            };
        },
    },
};
